import { render, staticRenderFns } from "./UndelegationModal.vue?vue&type=template&id=3ec13c20&"
import script from "./UndelegationModal.vue?vue&type=script&lang=js&"
export * from "./UndelegationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports